// extracted by mini-css-extract-plugin
var _1 = "VNUG1MwSW6gW3uiklMd1";
var _2 = "F9NA7kVdeAE2FXeAzoBg";
var _3 = "pRb4STw0w_URo0M7DPcd";
var _4 = "gdjTR6_7Rf85w8kuqUc6";
export { _1 as "themeTabs", _2 as "themeTabsItem", _3 as "themeTabsItemActive", _4 as "themeTabsList" }
